import Select from "@UI/New/Select";
import { directionAPI } from "@/api";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import s from './index.module.css';
import useLoad from "@/hooks/useLoad";
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";

export const CourseSelection = ({state, setFieldInState}) => {
   
    const { state: courses, loading } = useLoad({
        api: directionAPI.getAll,
        initState: [],
        key: 'data',
    })

    const fieldsCourse = {
        loading,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: filterOptionsByLabel,
        onChange: e => setFieldInState(
            {
                field: 'direction_id', 
                value: e, 
                resetFields: ['teacher_id', 'group_id']
            }
        ),
        options: courses.map(course => ({label: course.name, value: course.id})),
        value: state.direction_id,
        placeholder: 'Выберите курс',
        notFoundContent: "Курсы не найдены" 
    };

    return (
        <Select 
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
            fields={fieldsCourse} 
        />
    );
};